/*
 * @Author: Merlin
 * @Date: 2024-02-02 10:14:37
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-04 15:35:22
 * @Description: 文档说明： 文件名头部的数字表示插件注册顺序
 */

console.log('🚩 First plugin installation started');


export default defineNuxtPlugin((nuxtApp) => {
    // 防止连点：<div v-click-and-rest />
    // 
    nuxtApp.vueApp.directive('click-and-rest', {
        beforeMount (el, oBinding) {
            const {value = 500} = oBinding;
            const unlocker = ()=>{
                // ↓ 若 dom 被移除，则 return 
                if (Boolean(el?.isConnected) == false) return;
                const setDisabled = el.getAttribute('dismark') === 'true';
                // import.meta.dev && console.log('执行解锁？', !setDisabled);
                // ↓ 判断通过，说明元素已经被设为禁用状态，不要解锁
                if (setDisabled) return;
                el.disabled = false;
            };
            el.addEventListener('click', () => {
                el.disabled = true;
                setTimeout(unlocker, value);
            });
        },
    });
});

